import { useState, useEffect, useRef } from "react";
import useAuth from "../useAuth"
import Player from "./Player"
import TrackSearchResult from "./TrackSearchResult"
import { Container, Form } from "react-bootstrap"
import SpotifyWebApi from "spotify-web-api-node"
import axios from "axios"
import UserPoints from "./UserPoints";
import Sidebar from "./Sidebar";
import "../styles/dashboard.css";
import GenreSlider from "./GenreSlider";
import AppLogo from './AppLogo';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "../routes/Home";
import MyCampaigns from "../routes/MyCampaigns";
import ListenAndEarn from "../routes/ListenAndEarn";
import UserListens from "./UserListens";
import UserProfile from "./userProfile";
const spotifyApi = new SpotifyWebApi({
  clientId: "724e3751d2f346eab35f922c9b2826b4",
})

export default function Dashboard({ code }) {
  const pointsRef = useRef();
  const listensRef = useRef();
  const campaignsRef = useRef();
  const [search, setSearch] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [playingTrack, setPlayingTrack] = useState()
  const [lyrics, setLyrics] = useState("")
  const [genre, setGenre] = useState("");
  const { accessToken: token, userData } = useAuth(code);
  const [accessToken, setAccessToken] = useState(null);
  const [recentTracks, setRecentTracks] = useState([]);
  const [points, setPoints] = useState(null);
  const [listens, setListens] = useState(null);

  const handlePointsChange = (newPoints) => {
    setPoints(newPoints);
  };

  const handleListensChange = (newListens) => {
    setListens(newListens);
  };

  useEffect(() => {
    if (token) {
      setAccessToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (!accessToken) return;
    console.log(accessToken);
    spotifyApi.setAccessToken(accessToken);
    spotifyApi
      .getMyRecentlyPlayedTracks({ limit: 12 })
      .then((data) => {
        console.log("getMyRecentlyPlayedTracks:", data);
        if (!data.body || !data.body.items) {
          console.warn("No recently played tracks found.");
          setRecentTracks([]);
          return;
        }

        const tracks = data.body.items.map((item) => {
          const track = item.track;
          const smallestAlbumImage = track.album.images.reduce(
            (smallest, image) => {
              if (image.height > smallest.height) return image;
              return smallest;
            },
            track.album.images[0]
          );
          return {
            artist: track.artists[0].name,
            title: track.name,
            uri: track.uri,
            albumUrl: smallestAlbumImage.url,
            duration: track.duration_ms,
          };
        });

        const uniqueTracks = Array.from(
          new Map(tracks.map((track) => [track.uri, track])).values()
        );

        setRecentTracks(uniqueTracks);
      })
      .catch((err) => console.error("Error fetching recently played tracks", err));
  }, [accessToken]);

  function chooseTrack(track) {
    setPlayingTrack(track)
    setLyrics("")
  }
  const searchByGenre = (genre) => {
    spotifyApi.searchTracks(`genre:${genre}`).then((res) => {
      const tracks = res.body.tracks.items.map((track) => {
        const smallestAlbumImage = track.album.images.reduce(
          (smallest, image) => {
            if (image.height > smallest.height) return image;
            return smallest;
          },
          track.album.images[0]
        );
        return {
          artist: track.artists[0].name,
          title: track.name,
          uri: track.uri,
          albumUrl: smallestAlbumImage.url,
          duration: track.duration_ms,
        };
      });
      setSearchResults(tracks);
    });
  };
  const handleGenreClick = (genre) => {
    setGenre(genre);
    searchByGenre(genre);
  };
  useEffect(() => {
    if (!playingTrack) return

    axios
      .get(`${process.env.REACT_APP_BACK4APP_SERVER_PATH}/lyrics`, {
        params: {
          track: playingTrack.title,
          artist: playingTrack.artist,
        },
      })
      .then(res => {
        setLyrics(res.data.lyrics)
      })
  }, [playingTrack])

  useEffect(() => {
    console.log(playingTrack);
  }, [playingTrack]);

  const resetSearchAndGenre = () => {
    setSearch("");
    setGenre("");
  };

  useEffect(() => {
    if (!accessToken) return
    spotifyApi.setAccessToken(accessToken)
  }, [accessToken])

  useEffect(() => {
    if (!search) return setSearchResults([]);

    const trackUrlRegex = /^https:\/\/open\.spotify\.com\/track\/([a-zA-Z0-9]+)/;
    const artistUrlRegex = /^https:\/\/open\.spotify\.com\/artist\/([a-zA-Z0-9]+)/;

    const cleanSearch = search.split('?')[0];

    const matchTrack = cleanSearch.match(trackUrlRegex);
    const matchArtist = cleanSearch.match(artistUrlRegex);

    if (matchTrack) {
      const trackId = matchTrack[1];
      spotifyApi
        .getTrack(trackId)
        .then((res) => {
          const track = res.body;

          const smallestAlbumImage = track.album.images.reduce(
            (smallest, image) => {
              if (image.height > smallest.height) return image;
              return smallest;
            },
          );

          setSearchResults([
            {
              artist: track.artists[0].name,
              title: track.name,
              uri: track.uri,
              albumUrl: smallestAlbumImage.url,
              duration: track.duration_ms,
            },
          ]);
        })
        .catch((err) => console.error("Error fetching track: ", err));
    } else if (matchArtist) {
      const artistId = matchArtist[1];
      spotifyApi
        .getArtistTopTracks(artistId, 'US')
        .then((res) => {
          const tracks = res.body.tracks;
          setSearchResults(
            tracks.map((track) => {
              const smallestAlbumImage = track.album.images.reduce(
                (smallest, image) => {
                  if (image.height > smallest.height) return image;
                  return smallest;
                },
                track.album.images[0]
              );

              return {
                artist: track.artists[0].name,
                title: track.name,
                uri: track.uri,
                albumUrl: smallestAlbumImage.url,
                duration: track.duration_ms,
              };
            })
          );
        })
        .catch((err) => console.error("Error fetching artist's top tracks: ", err));
    } else {
      if (!accessToken) return;

      let cancel = false;
      spotifyApi.searchTracks(search).then((res) => {
        if (cancel) return;
        setSearchResults(
          res.body.tracks.items.map((track) => {
            const smallestAlbumImage = track.album.images.reduce(
              (smallest, image) => {
                if (image.height > smallest.height) return image;
                return smallest;
              },
              track.album.images[0]
            );

            return {
              artist: track.artists[0].name,
              title: track.name,
              uri: track.uri,
              albumUrl: smallestAlbumImage.url,
              duration: track.duration_ms,
            };
          })
        );
      });

      return () => (cancel = true);
    }
  }, [search, accessToken]);

  return (
    <Router>
      <div className="layout">
        <div class="sidebar">
          <div style={{ marginBottom: "40px" }}>
            <AppLogo />
          </div>
          <UserPoints ref={pointsRef} accessToken={accessToken} onPointsChange={handlePointsChange} />
          <UserListens ref={listensRef} accessToken={accessToken} onListenChange={handleListensChange} />
          <Sidebar points={points} campaignsRef={campaignsRef} resetSearchAndGenre={resetSearchAndGenre} accessToken={accessToken} pointsRef={pointsRef} />
        </div>
        <div className="main-content">
          <Container className="d-flex flex-column py-2" style={{ height: "100vh" }}>
            <div className="content-head">
              <Form.Control
                type="search"
                placeholder="Search Songs/Artists or Paste Spotify URL"
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="search-bar"
              />
              <div className="user-profile-wrapper">
                <UserProfile avatarUrl={userData?.avatarUrl} userName={userData?.userName} />
              </div>
            </div>
            <GenreSlider handleGenreClick={handleGenreClick} />
            <div className="flex-grow-1 my-2" style={{ overflowY: "auto" }}>
              {search || genre ? (
                <div className="track-layout">
                  {searchResults.map(track => (
                    <TrackSearchResult
                      track={track}
                      key={track.uri}
                      chooseTrack={chooseTrack}
                      playingTrack={playingTrack}
                    />
                  ))}
                </div>
              ) : (
                <Routes>
                  <Route
                    path="/"
                    element={
                      <Home
                        recentTracks={recentTracks}
                        chooseTrack={chooseTrack}
                        playingTrack={playingTrack}
                      />
                    }
                  />
                  <Route
                    path="/listen-and-earn"
                    element={
                      <ListenAndEarn
                        chooseTrack={chooseTrack}
                        playingTrack={playingTrack}
                        accessToken={accessToken}
                      />
                    }
                  />
                  <Route path="/my-campaigns" element={<MyCampaigns accessToken={accessToken} ref={campaignsRef} pointsRef={pointsRef} />} />
                </Routes>
              )}
            </div>
            <div>
              <Player accessToken={accessToken} trackUri={playingTrack?.uri} duration={playingTrack?.duration} listensRef={listensRef} pointsRef={pointsRef} />
            </div>
          </Container>
        </div>
      </div>
    </Router>
  )
}
